<template>
  <div class="servicios">
    <Header />
    <div class="contenedorServicios texto">
      <h2 class="titulo-global">Consulta Especializada</h2>
      <div>
        <h3 class="titulo-componente">Consulta Neumología Adultos</h3>
        <img src="../assets/img/consulta-adultos.jpg" align="left" />
        <p>
          La consulta médica especializada para pacientes adultos con enfermedad
          respiratoria. Es realizada por médico especialista en Medicina Interna
          y Neumología.
        </p>
        <p>Nos especializamos en patologías como:</p>
        <ul>
          <li>Hipertención Pulmonar</li>
          <li>ASMA</li>
          <li>EPOC (Enfermedad Pulmonar Obstructiva Crónica)</li>
          <li>Sueño</li>
          <li>EPID (Enfermedad Pulmonar Inersticial Difusa)</li>
          <li>Bronquitis</li>
          <li>Fibrosis Quística</li>
          <li>Enfermedades Neuromusculares (ELA)</li>
        </ul>
      </div>
      <hr />
      <div>
        <h3 class="titulo-componente">Consulta Neumología Pediátrica</h3>
        <img src="../assets/img/consulta-pediatrica.jpg" align="left" />
        <p>
          Servicio de consulta médica especializada para la atención del
          paciente en edad pediátrica con enfermedad respiratoria. Es realizada
          por médico especialista en pediatría y neumología.
        </p>
        <p>Nos especializamos en patologías como:</p>
        <ul>
          <li>Hipertención Pulmonar</li>
          <li>ASMA</li>
          <li>EPOC (Enfermedad Pulmonar Obstructiva Crónica)</li>
          <li>Sueño</li>
          <li>Fibrosis Quística</li>
          <li>Sueño en niños</li>
          <li>Otras</li>
        </ul>
      </div>
      <hr />
      <div>
        <h3 class="titulo-componente">Consulta Trastornos del Sueño</h3>
        <img src="../assets/img/consulta-trastorno.jpg" align="left" />
        <p>
          Si roncas, no duermes bien, o no dejas dormir, no deberías esperar más
          y solucionar tu problema. Nosotros nos encargamos de todo, para cuidar
          de tu sueño y de tu salud…porque dormir bien es imprescindible para
          vivir mejor.
        </p>
        <p>
          El servicio de consulta especializada interdisciplinaria en los
          trastornos del sueño, es realizada por neumólogos y neurólogos
          especialistas en sueño (adultos y pediátricos).
        </p>
        <p>
          Nuestros servicios se extienden al diagnóstico y al tratamiento de
          todos los trastornos del sueño:
        </p>
        <h4 class="subtitulo-componente">Apnea del sueño</h4>
        <p>
          La apnea del sueño es un trastorno común en el que la persona que lo
          sufre hace una o más pausas en la respiración o tiene respiraciones
          superficiales durante el sueño.
        </p>
        <p>
          Las pausas pueden durar entre unos pocos segundos y varios minutos. A
          menudo ocurren entre 30 veces o más por hora. Por lo general, la
          respiración vuelve a la normalidad, a veces con un ronquido fuerte o
          con un sonido parecido al que una persona hace cuando se atraganta.
        </p>
        <p>
          Casi siempre la apnea del sueño es un problema crónico (constante) de
          salud que altera el sueño. La persona pasa de un sueño profundo a un
          sueño liviano cuando hay una pausa en la respiración o cuando la
          respiración se vuelve superficial. Por esta razón, el sueño es de mala
          calidad y se siente cansancio durante el día. La apnea del sueño es
          una de las principales razones por las cuales una persona puede sentir
          mucho sueño durante el día.
        </p>
        <h4 class="subtitulo-componente">
          La apnea del sueño que no recibe tratamiento puede:
        </h4>
        <ul>
          <li>
            Aumentar el riesgo de sufrir presión arterial alta, ataque cardíaco,
            accidente cerebrovascular (derrame cerebral) , obesidad y diabetes
          </li>
          <li>
            Aumentar el riesgo de que ocurra insuficiencia cardíaca o de que
            ésta empeore
          </li>
          <li>
            Aumentar las probabilidades de que haya arritmias o latidos
            irregulares del corazón
          </li>
          <li>
            Aumentar las probabilidades de sufrir accidentes automovilísticos o
            de trabajo
          </li>
        </ul>
        <p>
          La apnea del sueño es un problema crónico de salud que requiere un
          tratamiento a largo plazo. Los cambios en el estilo de vida, los
          dispositivos bucales, la cirugía o los dispositivos respiratorios
          pueden tener éxito en el tratamiento de la apnea del sueño en muchas
          personas.
        </p>
        <h4 class="subtitulo-componente">
          Signos de ALARMA para la sospecha SAHOS:
        </h4>
        <ul>
          <li>Presencia de ronquido fuerte.</li>
          <li>
            Presencia de ronquido interrumpido por pausas respiratorias y que
            vuelven a respirar con un jadeo y/o sensación de ahogo.
          </li>
          <li>
            Somnolencia diurna en situaciones no adecuadas (trabajo,
            conduciendo, reuniones…)
          </li>
          <li>
            Dificultad para concentrarse, ser mas despistado, irritable, ansioso
            y/o depresivo.
          </li>
          <li>
            Dolores de cabeza al despertar, frecuentes viajes al lavabo a
            orinar.
          </li>
          <li>
            Pérdida de interés en el sexo. Algunos hombres pueden manifestar
            impotencia y las mujeres pueden tener irregularidades en la
            menstruación.
          </li>
          <li>
            Estos síntomas aparecen de forma lenta y gradual en el transcurso de
            años, por lo que el paciente puede no reconocer estos síntomas.
          </li>
        </ul>
        <p>
          Muchas veces el paciente cree estos síntomas se relacionan con la edad
          o bien que no tienen importancia. Familiares, compañeros y amigos
          tienen que ser los primeros en reconocer este patrón y convencer al
          paciente para visitar a un profesional médico.
        </p>
        <h4 class="subtitulo-componente">Ronquido</h4>
        <p>
          El ronquido no constituye ningún síntoma de bienestar o de un mejor
          descanso, realmente su presencia demuestra que existe algún problema
          al cual se debe prestar mucha atención.
        </p>
        <p>
          El ronquido se caracteriza por ser un sonido respiratorio fuerte
          producido en las vías respiratorias altas durante el sueño. Es
          frecuente que sea lo suficientemente fuerte como para molestar a los
          acompañantes, mientras que el individuo es ajeno al mismo. Suele
          presentarse en decúbito supino (“Acostado boca arriba”) y normalmente
          es continuo. No va acompañado de insomnio o somnolencia excesiva.
        </p>
        <p>
          La obesidad, la retrognatia (mandíbula hacia atrás), sustancias
          depresoras del sistema nervioso central, la congestión u obstrucción
          nasal son factores que predisponen. La prevalencia aumenta con la
          edad, llegando al 50% de los pacientes mayores de 65 años, con mayor
          predisposición por los hombres.
        </p>
        <p>
          Consiste en un sonido ronco, el cual está producido por la vibración
          de los tejidos flexibles (el paladar blando contra la pared posterior
          de la faringe) en una vía aérea superior estrecha. Hay que
          considerarlo como un signo de obstrucción parcial de la vía aérea y,
          en consecuencia, un signo precoz de un trastorno obstructivo de la
          respiración, que con el tiempo puede conducir a un progresivo
          empeoramiento. El origen del sonido también puede estar en las fosas
          nasales. Se puede clasificar en:
        </p>
        <ul>
          <li>
            Ronquido simple. No molesta a los acompañantes ni hay evidencia
            objetiva de resistencias de la vía aérea superior..
          </li>
          <li>
            Ronquido alto habitual o ronquido social. Molesta al acompañante o
            convivientes, pero sin resistencias de la vía aérea superior. Este
            tipo de ronquido se suele considerar como simple.
          </li>
          <li>
            Ronquido acompañado de Síndrome de Apnea Obstructiva del Sueño
            (SAHOS). Apnea (cese completo de la respiración de al menos 10
            segundos)
          </li>
          <li>
            Aprenda mas sobre la Apnea del Sueño. Averigüe si padece de apneas
            del sueño
          </li>
          <li>Imsomnio</li>
          <li>
            Si usted tiene problemas para conciliar y mantener el sueño durante
            toda la noche, entonces sufre de insomnio. Y si piensa que este
            trastorno es sólo una molestia nocturna, está equivocado: un mal
            dormir repercute en la etapa de vigilia y afecta la calidad de vida
            de quien lo sufre al comprometer las actividades que realiza durante
            el día. Somnolencia excesiva
          </li>
          <li>
            Imagine su día por completo bajo la influencia de una gran
            somnolencia: se hace difícil concentrarse y mantener el interés en
            cualquier actividad que se intente realizar. Desde una llamada
            telefónica hasta ver una película o conducir hasta casa.
          </li>
        </ul>
        <h4 class="subtitulo-componente">Terrores nocturnos</h4>
        <p>
          Los terrores del sueño son parasomnias muy dramáticas y llamativas que
          asustan mucho a la familia del paciente. Si bien son más comunes en la
          infancia temprana, pueden ocurrir a cualquier edad.
        </p>
        <p>
          Son episodios que ocurren en forma repentina, aterrorizando al
          paciente y preocupando mucho a los padres, pues el niño se sienta
          rígido dando alaridos de terror, con ojos abiertos y pupilas
          dilatadas.
        </p>
        <h4 class="subtitulo-componente">Parasomnias</h4>
        <p>
          No todos los sueños son dulces y placenteros como los deseamos cuando
          ponemos la cabeza en la almohada. Existen trastornos o desórdenes
          clínicos asociados a fenómenos físicos que pueden suceder en distintas
          etapas del sueño y que se conocen como parasomnias. El sonambulismo,
          los terrores del sueño y las pesadillas se cuentan entre ellas.
        </p>
        <h4 class="subtitulo-componente">Síndrome de Piernas Inquietas</h4>
        <p>
          Este es un trastorno en el cual se desea o necesita mover las piernas
          para interrumpir sensaciones molestas.
        </p>
      </div>
      <hr />
      <div>
        <h3 class="titulo-componente">Clínica del Sueño</h3>
        <img src="../assets/img/clinica-sueno.jpg" align="left" />
        <p>
          En NEUMOMED somos especialistas en las enfermedades relacionadas con
          el Sueño. Los problemas de:
        </p>
        <ul>
          <li>Ronquido</li>
          <li>Apnea del sueño</li>
          <li>Conciliación del sueño</li>
          <li>Parasomnias</li>
          <li>Somnolencia excesiva y narcolepcia</li>
          <li>Sueño en niños</li>
        </ul>
        <p>
          Son abordados por nuestros especialistas buscando un diagnóstico
          confiable, con equipos especializados para identificar las causas de
          su problema.
        </p>
        <p>
          Asi mismo los especialistas en NEUMOMED brindaran las soluciones
          apropiadas para corregir o desaparecer el trastorno.
        </p>
        <p>
          Si roncas, no duermes bien, o no dejas dormir, no deberías esperar más
          y solucionar tu problema. Nosotros nos encargamos de todo, para cuidar
          de tu sueño y de tu salud…porque dormir bien es imprescindible para
          vivir mejor.
        </p>
        <p>
          El servicio de consulta especializada interdisciplinaria en los
          trastornos del sueño, es realizada por neumólogos y neurólogos
          especialistas en sueño (adultos y pediátricos).
        </p>
        <p>
          Nuestros servicios se extienden al diagnóstico y al tratamiento de
          todos los trastornos del sueño:
        </p>
        <p>Algunos de los tratamientos que ofrece NEUMOMED:</p>
        <ul>
          <li>CPAP Nasal</li>
          <li>Tratamiento Postural</li>
          <li>Dispositivos de Avance Mandibular.</li>
          <li>Medicamentos ( De acuerdo a indicación médica)</li>
        </ul>
      </div>
      <hr />
      <div>
        <h3 class="titulo-componente">Ayudas Diagnósticas</h3>
        <img src="../assets/img/ayudas-diagnosticas.jpg" align="left" />
        <p>
          En nuestro centro contamos con la tecnología para ayudar a los
          especialistas a determinar el diagnóstico del trastorno del sueño o de
          la patología respiratoria que afecta su salud.
        </p>
        <p>NEUMOMED ofrece las siguientes ayudas diagnósticas.</p>
        <ul>
          <li>
            Preparación para Espirometría. (Simple o con broncoprovocación)
          </li>
          <li>Prueba de broncoprovocación con ejercicio.</li>
          <li>Preparación para Caminata de 6 Minutos.</li>
          <li>Oximetría diurna y Nocturna.</li>
          <li>Capnografía diurna y nocturna.</li>
          <li>Prueba de Ejercicio Incremental.</li>
          <li>Prueba de tolerancia al ejercicio.</li>
          <li>Cooximetría.</li>
          <li>
            Recomendaciones para la realización de Polisomnograma (Adultos)
          </li>
          <li>Recomendaciones para Polisomonograma (Bebé)</li>
          <li>Poligrafía respiratoria.</li>
          <li>Prueba latencias múltiples del sueño.</li>
          <li>Titulación de CPAP.</li>
        </ul>
      </div>
      <hr />
      <h2 class="titulo-global">Clínica de Trastornos del Sueño</h2>
      <div>
        <h3 class="titulo-componente">Trastorno del Sueño en Niños</h3>
        <img src="../assets/img/trastorno-ninos.jpg" align="left" />
        <p>
          El carácter y estado de ánimo de su hijo se ve afectado por una pobre
          calidad de sueño? ¿Se duerme su hijo durante el día? ¿Pierde usted
          horas de sueño haciendo dormir a su hijo? ¿La dificultad y mala
          calidad de sueño de su hijo interfiere en su pareja?
        </p>
        <p>
          Existen muchas preguntas para intentar detectar los problemas de los
          niños en la infancia, pero las respuestas a muchas de ellas, se verán
          condicionadas por la edad que presente el niño y lo que una respuesta
          en una edad podría ser normal, en otra se puede considerar anormal.
          Evalúe de forma rápida y sencilla si su hijo podría esconder un
          trastorno del sueño (test) Cuestionario Pediátrico del sueño.
        </p>
        <p>
          No hay que olvidar que el niño es un ser que desde que nace hasta que
          se hace adulto esta en un proceso de cambio constante y esto también
          sucede con el sueño. Es por eso, que es muy importante conocer el
          patrón normal de sueño que presenta un niño en las diferentes edades,
          para entonces poder diferenciar y detectar de forma precoz cuando un
          niño no está disfrutando de un sueño saludable.
        </p>
        <p>
          Revise los signos de alarma que nos podrían sugerir un trastorno de
          sueño en su hijo (Signos de Alarma) En la última clasificación
          internacional de los trastornos de sueño ya se han descrito más de 90
          trastornos de sueño. Además existen en la actualidad abundantes
          estudios en los que se ha demostrado que la presencia y persistencia
          de trastornos de sueño en la infancia puede tener consecuencias tanto
          en el crecimiento y en el desarrollo psíquico, como en el aumento en
          los factores de riesgo cardiovasculares e incluso se ha relacionado
          con procesos de muerte súbita.
        </p>
      </div>
      <hr />
      <div>
        <h3 class="titulo-componente">
          Solucion al Ronquido y Apnea del Sueño
        </h3>
        <div>
          <h3 class="titulo-componente">Tratamiento con CPAP</h3>
          <img src="../assets/img/tratamiento-cpap.jpg" align="left" />
          <p>
            Presión positiva continua de aire (CPAP): Es el tratamiento más
            efectivo y consiste en aplicar aire en el sistema respiratorio
            usando un compresor eléctrico conectado a una mascarilla sellada
            sobre la nariz y/o la boca durante el sueño, lo que permite la
            apertura permanente de las estructuras musculares que bloquean el
            paso del aire. Existen mascaras de CPAP con muy diversos tipos de
            formas y tamaños. También existen que solo cubren la nariz o bien la
            nariz y la boca.
          </p>
          <p>
            Es muy importante tener un seguimiento por un especialista en
            trastornos del sueño para lograr la tolerancia a la máscara.
          </p>
          <h5 class="subtitulo-componente">Quién debe usar la CPAP</h5>
          <p>
            La presión positiva continua en la vía aérea (CPAP, por sus siglas
            en inglés) es el mejor tratamiento para la mayoría de las personas
            con apnea obstructiva del sueño. Es seguro y eficaz en pacientes de
            todas las edades, incluyendo los niños. Si usted sólo tiene apnea
            del sueño leve y no se siente muy soñoliento durante el día,
            posiblemente no necesite usarlo. Después de usar CPAP regularmente
            muchos pacientes informan lo siguiente:
          </p>
          <ul>
            <li>Mejor concentración y memoria</li>
            <li>Sentirse más despierto y menos soñoliento durante el día</li>
            <li>
              Mejoramiento del sueño de los compañeros de cama de la persona
            </li>
            <li>Mejoramiento en la productividad laboral</li>
            <li>Menos ansiedad y depresión y mejor estado anímico</li>
            <li>Patrones de sueño normales</li>
            <li>
              Mejoramiento en los problemas cardiovasculares, como hipertensión
              arterial
            </li>
          </ul>
          <p>
            Una máquina similar, llamada BiPAP (para presión positiva de dos
            niveles en la vía aérea), se utiliza como alternativa a la CPAP. Con
            esta máquina, la presión cambia mientras la persona inhala y exhala.
          </p>
          <p>
            Estos dispositivos sirven para niños y adultos con vías
            respiratorias que pueden colapsar, volumen pulmonar pequeño o
            debilidad muscular que dificulta la respiración, como distrofia
            muscular.
          </p>
          <h5 class="subtitulo-componente">
            La CPAP o la BiPAP también las pueden utilizar personas que tienen:
          </h5>
          <ul>
            <li>Insuficiencia respiratoria aguda</li>
            <li>Apnea central del sueño</li>
            <li>EPOC</li>
            <li>Insuficiencia cardíaca</li>
          </ul>
          <p>
            Tratamiento postural: que evita dormir en decúbito supino ( Boca
            Arriba) y favorece dormir en decúbito lateral (De lado) . La mayoría
            de los eventos respiratorios se agravan al adoptar la posición de
            boca arriba, aumentando así tanto en duración como en intensidad.
            Este tratamiento consiste en controlar la posición del paciente para
            evitar dormir boca arriba. Cuando se han comparado estas medidas
            antisupino con el CPAP, se ha observado que ambas técnicas son igual
            de eficaces para mejorar la estructura del sueño y disminuir la
            somnolencia diurna, aunque sigue siendo mas eficaz el CPAP
            disminuyendo el índice de eventos respiratorios y en mejorar las
            alteraciones del intercambio gaseoso.
          </p>
          <p>
            En NEUMOMED contamos con los dispositivos que ayudan a corregir la
            postura al dormir, podemos realizar la verificación del control y
            corrección de los eventos respiratorios mediante un examen
            ambulatorio de poligrafía respiratoria que acompaña al corrector de
            postura. NEUMOMED ofrece un seguimiento completo en el proceso de
            adaptación de los dispositivos correctores con el fin de garantizar
            un avance en el control de los eventos respiratorios adversos en los
            pacientes.
          </p>
          <p>
            Dispositivos de avance mandibular (DAM): Es un sistema bucal
            intraoral, que actúa adelantando la mandíbula permitiendo así
            aumentar el diámetro retrofaríngeo. Aunque existen varios modelos en
            el mercado, todos ellos consisten en dos férulas que se anclan en la
            arcada dental superior e inferior, unidas a través de dos bielas,
            que se encargan de mantener la mandíbula inferior en un aposición
            mas adelantada. Si comparamos este dispositivo con el CPAP
            encontramos que es discretamente inferior en eficacia para disminuir
            el IAH y mejorar los parámetros de intercambio gaseoso pero igual de
            eficaz para mejorar la arquitectura del sueño y la somnolencia.
          </p>
          <p>
            Los pacientes con roncopatía y SAHOS en grado leve-moderado se
            pueden beneficiar de este tipo de tratamiento, siempre y cuando
            tengan un buen diagnóstico realizado con polisomnografía y/o
            poligrafía cardiorespiratoria, una fisonomía adecuada y no tengan
            contraindicaciones para su empleo. Es por este motivo que este
            sistema tiene que ser administrado y controlado por un odontólogo
            con alta experiencia en la apnea del sueño. También puede ser una
            alternativa para pacientes con SAHOS en grado grave y que no toleran
            el CPAP o bien en pacientes con CPAP que quieran combinar terapia a
            dias alternos.
          </p>
        </div>
        <div>
          <h3 class="titulo-componente">Tratamiento Posicional</h3>
          <img src="../assets/img/tratamiento-posicional.jpg" align="left" />
          <p>
            La mayoría de los eventos respiratorios se agravan al adoptar la
            posición de boca arriba, a umentando así tanto en duración como en
            intensidad. Este tratamiento consiste en controlar la posición del
            paciente para evitar dormir boca arriba.
          </p>
          <p>
            En NEUMOMED contamos con los dispositivos que ayudan a corregir la
            postura al dormir, podemos realizar la verificación del control y
            corrección de los eventos respiratorios mediante un examen
            ambulatorio de poligrafía respiratoria que acompaña al corrector de
            postura.
          </p>
          <p>
            NEUMOMED ofrece un seguimiento completo en el proceso de adaptación
            de los dispositivos correctores con el fin de garantizar un avance
            en el control de los eventos respiratorios adversos en los
            pacientes.
          </p>
        </div>
      </div>
      <hr />
    </div>
    <BotonesAgendar style="margin: 64px auto" />
    <!-- <Chat /> -->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header/Header.vue";
import Footer from "../components/Footer/Footer.vue";
import BotonesAgendar from "../components/BotonesAgendar/BotonesAgendar";
// import Chat from "../components/Chat/Chat";

export default {
  name: "servicios",
  components: {
    Header,
    Footer,
    // Chat,
    BotonesAgendar
  }
};
</script>

<style lang="scss">
@import "../assets/sass/utils/mixins";
.contenedorServicios {
  width: 700px;
  margin: 0 auto;
  @include for-phone-only {
    width: 288px;
  }

  // @include for-tablet-portrait-up {
  //   width: 80vw;
  // }
  h2,
  h3,
  h4,
  h5,
  p,
  ul {
    margin-bottom: 16px;
  }

  h2,
  h3 {
    color: darken(#3cf, 16) !important;
  }

  h4,
  h5 {
    color: darken(#646a6f, 15) !important;
  }

  // ul {
  //   @include for-desktop-up {
  //     margin-left: 24px;
  //   }
  // }

  img {
    width: 256px;
    margin-right: 24px;
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    @include for-phone-only {
      width: 100%;
    }
  }
  hr {
    margin: 24px 0;
    border: 1px solid #646a6f;
  }
}
</style>
